var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBusinessDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.205 3.5v.911h3.59v21.177H2.435V4.412l3.59-.001V3.5h7.18zM8.897 18.53H4.59v4.235h4.307v-4.236zm5.744 0h-4.308v4.235h4.308v-4.236zm-5.744-5.648H4.59v4.236h4.307v-4.236zm5.744 0h-4.308v4.236h4.308v-4.236zM8.897 7.235H4.59v4.236h4.307V7.235zm5.744 0h-4.308v4.236h4.308V7.235zM24.692 7.75v.632h2.872v17.206h-10.41V8.382h1.794V7.75h5.744zm-3.446 12.103H17.8v3.441h3.446v-3.441zm4.595 0h-3.446v3.441h3.446v-3.441zm-4.595-4.588H17.8v3.44h3.446v-3.44zm4.595 0h-3.446v3.44h3.446v-3.44zm-4.595-4.589H17.8v3.442h3.446v-3.442zm4.595 0h-3.446v3.442h3.446v-3.442zM1 25.588h28V27H1z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBusinessDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-business-default.70d7540a86d204708968f30d8ad11bf8.svg";